import { useClickOutside } from "@/lib/hooks/useClickOutside";
import { imageLoader } from "@/lib/sanity/client";
import NextImage from "next/image";
import { useRef, useState } from "react";
import Hotspot, { HotspotProps } from "./Hotspot";
import { Container, ImageContainer, Heading } from "./styles";

export type ImageWithHotspotsProps = {
  _key: string;
  image: {
    asset: {
      url: string;
      aspectRatio: number;
    } | null;
  } | null;
  heading?: string;
  hotspots: HotspotProps[] | null;
};

const ImageWithHotspots: React.FC<ImageWithHotspotsProps> = (props) => {
  const { image, hotspots, heading } = props;
  const [loaded, setLoaded] = useState<boolean>(false);
  const [activeHotspot, setActiveHotspot] = useState<string | null>();

  const containerRef = useRef<HTMLDivElement>(null);
  useClickOutside(containerRef, () => {
    setActiveHotspot(null);
  });

  return (
    <Container ref={containerRef}>
      {heading && <Heading>{heading}</Heading>}
      <ImageContainer
        $hasLoaded={loaded}
        $aspectRatio={image?.asset?.aspectRatio || 1}
        $blur={!!activeHotspot}
      >
        {image?.asset?.url && (
          <NextImage
            src={image.asset.url}
            layout="fill"
            objectFit="cover"
            alt={""} // TODO: should we have this?
            loader={imageLoader}
            onLoadingComplete={() => setLoaded(true)}
            sizes="50vw"
            quality={100}
            draggable={false}
          />
        )}
        {hotspots?.map((hotspot) => (
          <Hotspot
            key={hotspot._key}
            {...hotspot}
            isActive={hotspot._key === activeHotspot}
            setActive={() => setActiveHotspot(hotspot._key)}
            setInactive={() => setActiveHotspot(null)}
          />
        ))}
      </ImageContainer>
    </Container>
  );
};

export default ImageWithHotspots;
